import { DEFAULT_LABEL_STYLE, LabelStyle } from '../../../../store';
import { NEON_DEFAULT_OPACITY, neonColor } from '../../shared/labelBadge';

export interface LabelEditorStyleState {
  fontSize: number;
  fontWeight: NonNullable<LabelStyle['fontWeight']>;
  color: string;
  backgroundColor: string;
  backgroundOpacity: number;
  borderColor: string;
  padding: number;
  zIndex: number;
  variant: LabelStyle['variant'];
  skewX: number;
  skewY: number;
  perspectiveX: number;
  perspectiveY: number;
}

export function resolveLabelEditorStyleState(
  style: LabelStyle,
): LabelEditorStyleState {
  return {
    fontSize: style.fontSize ?? DEFAULT_LABEL_STYLE.fontSize,
    fontWeight: style.fontWeight ?? DEFAULT_LABEL_STYLE.fontWeight,
    color: style.color ?? DEFAULT_LABEL_STYLE.color,
    backgroundColor: style.variant === 'neon' ? neonColor(style) : style.backgroundColor ?? DEFAULT_LABEL_STYLE.backgroundColor,
    backgroundOpacity: style.backgroundOpacity
      ?? (style.variant === 'neon' ? NEON_DEFAULT_OPACITY : DEFAULT_LABEL_STYLE.backgroundOpacity),
    borderColor: style.borderColor ?? DEFAULT_LABEL_STYLE.borderColor,
    padding: style.padding ?? DEFAULT_LABEL_STYLE.padding,
    zIndex: style.zIndex ?? DEFAULT_LABEL_STYLE.zIndex,
    variant: style.variant,
    skewX: style.skewX ?? 0,
    skewY: style.skewY ?? 0,
    perspectiveX: style.perspectiveX ?? 0,
    perspectiveY: style.perspectiveY ?? 0,
  };
}
